import type { SVGProps } from 'react';
import { forwardRef, Ref } from 'react';

const SvgReparatie = (
  props: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>,
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 40 40"
    role="img"
    aria-hidden={true}
    ref={ref}
    {...props}
  >
    <path
      fill="#FF7842"
      fillRule="evenodd"
      d="M5.926 24.174a7.04 7.04 0 0 1 6.786-1.836l9.626-9.626a7.04 7.04 0 0 1 1.836-6.786A7.04 7.04 0 0 1 30.96 4.09l-4.31 4.311 4.949 4.95 4.31-4.311a7.04 7.04 0 0 1-1.835 6.786 7.04 7.04 0 0 1-6.786 1.836l-9.626 9.626a7.04 7.04 0 0 1-1.836 6.786A7.04 7.04 0 0 1 9.04 35.91l4.31-4.311-4.949-4.95-4.31 4.311a7.04 7.04 0 0 1 1.835-6.786"
      clipRule="evenodd"
    />
    <path
      fill="#00215B"
      d="m25.65 16.644.7.712-10.949 10.778-.701-.712zM10.536 36.92v1a9 9 0 1 1 0-18v1a8 8 0 0 0 0 16m0 0v1a9 9 0 1 1 0-18v1a8 8 0 0 0 0 16"
    />
  </svg>
);

/* eslint-disable import/no-default-export */
const ForwardRef = forwardRef(SvgReparatie);

export default ForwardRef;
